(function () {
    window.js = window.js || {};
    js.imagecompare = (function () {

        function initialize() {
            function imageSlider(elem) {
                var imageContainer = elem;
                var overlay = imageContainer.querySelector(".top-image");
                var range = imageContainer.querySelector(".range-slider");
                var images = imageContainer.querySelectorAll(".comparison-img");
                var handle = imageContainer.querySelector(".handle");
                images.forEach(function (elem) {
                    elem.style.width = range.offsetWidth + 'px'
                })
                range.oninput = function () {
                    if (this.value > 0) {
                        overlay.style.width = this.value + "%";
                        handle.style.left = this.value + "%";
                    } else {
                        overlay.style.width = 'calc(0% + 5px)';
                        handle.style.left = 'calc(0% + 5px)';
                    }
                }
            }

            const sliders = document.querySelectorAll('.image-slider-wrapper');
            function initImageSliders() {
                console.log('test')
                for (var i = 0; i < sliders.length; i++) {
                    imageSlider(sliders[i]);
                }
            }

            initImageSliders();
            window.addEventListener('resize', initImageSliders);
            window.dispatchEvent(new Event('resize'));
        }
            

        return {
            initialize: initialize
        };
    })();
})();